<span class="font-medium-title-large">{{
  isEditMode ? 'Gutschein bearbeiten' : 'Gutschein hinzufügen'
}}</span>

<form [formGroup]="couponForm" class="align-self-stretch flex-c gap-16">
  @if (couponType === 'promo') {
    <div class="radio-buttons">
      <label for="fixed" class="inwi-radio font-regular-body-large">
        <input
          id="fixed"
          type="radio"
          value="fixed"
          formControlName="discountType" />
        <span> Festbetrag </span>
      </label>
      <label for="percentage" class="inwi-radio font-regular-body-large">
        <input
          id="percentage"
          type="radio"
          value="percentage"
          formControlName="discountType" />
        <span> Prozentual </span>
      </label>
    </div>
    <div class="flex-r gap-16">
      <div class="input-simple flex-1-1-0">
        <label for="value" class="input-label">
          Sparen{{ fieldRequired(couponForm.get('value')) ? '*' : '' }}
        </label>
        <div class="input-wrapper">
          <input
            class="input-field"
            formControlName="value"
            name="value"
            id="value"
            type="text"
            placeholder="0" />
          <span class="input-suffix">{{
            couponForm.get('discountType')?.value === 'percentage' ? '%' : '€'
          }}</span>
        </div>
        <!-- <input
          type="text"
          id="value"
          name="value"
          class="input-field"
          placeholder="0"
          formControlName="value" /> -->
        <app-error-message
          [formField]="couponForm.get('value')"></app-error-message>
      </div>
      <div class="input-simple flex-1-1-0"></div>
    </div>
  } @else {
    <div class="flex-r gap-16">
      <div class="input-simple flex-1-1-0">
        <label for="payedAmount" class="input-label">
          Zahle{{ fieldRequired(couponForm.get('payedAmount')) ? '*' : '' }}
        </label>
        <input
          type="text"
          id="payedAmount"
          name="payedAmount"
          class="input-field"
          placeholder="0"
          formControlName="payedAmount" />
        <app-error-message
          [formField]="couponForm.get('payedAmount')"></app-error-message>
      </div>
      <div class="input-simple flex-1-1-0">
        <label for="receivedAmount" class="input-label">
          Erhalte{{
            fieldRequired(couponForm.get('receivedAmount')) ? '*' : ''
          }}
        </label>
        <input
          type="text"
          id="receivedAmount"
          name="receivedAmount"
          class="input-field"
          placeholder="0"
          formControlName="receivedAmount" />
        <app-error-message
          [formField]="couponForm.get('receivedAmount')"></app-error-message>
      </div>
    </div>
  }
  <div class="input-simple flex-1-1-0">
    <label for="title" class="input-label">
      Titel{{ fieldRequired(couponForm.get('title')) ? '*' : '' }}
    </label>
    <input
      type="text"
      id="title"
      name="title"
      class="input-field"
      placeholder="Titel"
      formControlName="title" />
    <app-error-message
      [formField]="couponForm.get('title')"></app-error-message>
  </div>

  <div class="input-simple flex-1-1-0">
    <div class="input-label-wrapper">
      <label for="description" class="input-label">
        Beschreibung{{
          fieldRequired(couponForm.get('description')) ? '*' : ''
        }}
      </label>
      <div class="input-label-hint">
        {{ getTextAreaLength(couponForm.controls['description']) }}
        /
        {{ getMaxLengthFromValidator(couponForm.controls['description']) }}
      </div>
    </div>
    <textarea
      id="description"
      name="description"
      class="input-textarea"
      rows="4"
      placeholder="Beschreibung"
      formControlName="description"></textarea>
    <app-error-message
      [formField]="couponForm.get('description')"></app-error-message>
  </div>

  @if (couponType === 'promo') {
    <div class="flex-r gap-16">
      <div class="input-simple flex-1-1-0">
        <label for="recipient" class="input-label">
          E-Mail{{ fieldRequired(couponForm.get('recipient')) ? '*' : '' }}
        </label>
        <input
          type="text"
          id="recipient"
          name="recipient"
          class="input-field"
          placeholder="mmustermann@example.com"
          formControlName="recipient"
          autocomplete="off" />
        <app-error-message
          [formField]="couponForm.get('recipient')"></app-error-message>
      </div>
      <div class="input-simple flex-1-1-0">
        <label for="code" class="input-label">
          Code{{ fieldRequired(couponForm.get('code')) ? '*' : '' }}
        </label>
        <input
          type="text"
          id="code"
          name="code"
          class="input-field"
          placeholder="Gutscheincode"
          formControlName="code" />
        <app-error-message
          [formField]="couponForm.get('code')"></app-error-message>
      </div>
    </div>

    <div class="input-simple flex-1-1-0">
      <div class="input-label-wrapper">
        <label for="allowedSeminarIds" class="input-label">
          @if (couponForm.get('seminarInverted')?.value) {
            Alle Seminare außer:
          } @else {
            Gültige Seminare
          }
        </label>
        <label
          for="seminarInverted"
          class="flex-r gap-8 align-center font-regular-body-medium text-secondary">
          <div class="inwi-checkbox">
            <input
              id="seminarInverted"
              type="checkbox"
              formControlName="seminarInverted" />
          </div>
          Alle außer
        </label>
      </div>
      <p-multiSelect
        id="allowedSeminarIds"
        appendTo="body"
        [options]="seminars"
        optionLabel="seminar.title"
        optionValue="seminar.id"
        placeholder="Seminare auswählen..."
        [loading]="isLoadingSeminars || isLoadingCouponCode"
        formControlName="allowedSeminarIds"
        [showClear]="true"
        [filter]="true"
        display="chip"
        styleClass="w-full"
        panelStyleClass="filter-seminar-select-panel">
        <ng-template let-seminar pTemplate="item">
          <div class="flex align-items-center">
            <div>{{ seminar.seminar.title }}</div>
            @if (seminar.dates && seminar.dates.length > 0) {
              <span class="font-regular-body-medium text-secondary">
                {{ getSeminarDateString(seminar) }}
              </span>
            }
            @if (seminar.seminar.isDraft) {
              <span class="is-draft-tag"> Entwurf</span>
            }
          </div>
        </ng-template>
      </p-multiSelect>
      <small class="text-secondary">
        @if (couponForm.get('seminarInverted')?.value) {
          Wenn leer, gilt der Code für alle Seminare. Ausgewählte Seminare sind
          ausgeschlossen.
        } @else {
          Wenn leer, gilt der Code für alle Seminare
        }
      </small>
    </div>

    <div class="input-simple flex-1-1-0">
      <label for="allowedConditionTypes" class="input-label">
        Gültig nur für bestimmte Preis-Kategorien (optional)
      </label>
      <p-multiSelect
        id="allowedConditionTypes"
        appendTo="body"
        [options]="conditionTypes"
        optionLabel="label"
        optionValue="value"
        placeholder="Preis-Kategorien auswählen..."
        formControlName="allowedConditionTypes"
        [showClear]="true"
        display="chip"
        styleClass="w-full">
      </p-multiSelect>
      <small class="text-secondary"
        >Wenn leer, gilt der Code für alle Preis-Kategorien</small
      >
    </div>
  }
</form>

<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    class="inwi-icon-text-button-large-secondary"
    (click)="closeDialog(false)">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-times"></i>
      </div>
      <div class="button-text">Abbrechen</div>
    </div>
  </button>
  <button
    type="button"
    [disabled]="couponForm.disabled || isLoadingCouponCode"
    (click)="closeDialog(true)"
    class="inwi-icon-text-button-large-primary">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-floppy-disk"></i>
      </div>
      <div class="button-text">
        {{ isEditMode ? 'Speichern' : 'Hinzufügen' }}
      </div>
    </div>
  </button>
</div>
